import api from '@pray/shared/utils/api';

export type ListAcquisitionCampaignsParams = {
  artistId: string;
  startDate?: string;
  endDate?: string;
};

export type AcquisitionCampaign = {
  campaign_id: string;
  campaign_name: string;
  spend: number;
};

export const listCampaigns = async ({ artistId, startDate, endDate }: ListAcquisitionCampaignsParams) => {
  const params: Record<string, string> = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const url = `/web/studio/artists/${artistId}/analytics/acquisition/campaigns`;
  const response = await api.executeGetRequest(url, params);
  return ((response.data as Record<string, unknown>)?.data ?? []) as AcquisitionCampaign[];
};
